import React from "react"
import { useTranslation } from "react-i18next"
import PPTarifView from "./PPTarifView"
import useRequireAuth from "../../hooks/use-require-auth"
import PPUtils from "../../utils/PPUtils"
import "../../styles/pricetable.css"

function insertInternalIdealoRedirectService(shopId, url) {
    if (url !== undefined && url.includes("idealohash://")) {
        url = "/resolveIdealoRedirects?hash=" + url.replace("idealohash://", "") + "&shopId=" + shopId
    }

    return url
}

function PPMerchantRow(props) {
    return (
        <li
            key={props.index + "_" + props.merchant.name.toString()}
            className={props.isCheapest ? "list-group-item-success" : "list-group-item"}
        >
            <a
                target="_blank"
                rel="noopener noreferrer"
                href={insertInternalIdealoRedirectService(props.foreignShop.shopId, props.merchant.url)}
            >
                <h5>
                    {props.merchant.name}{" "}
                    <span
                        className={`float-end badge badge-secondary stock-${props.merchant.stock}-font-color`}
                        style={{ backgroundColor: props.merchant.stock }}
                    >
                        {props.merchant.price.toFixed(2)}
                        {props.currencySymbol}
                        {localStorage.getItem("showTotalPrice") === "true" && (
                            <>
                                {" "}
                                ({props.merchant.totalPrice.toFixed(2)}
                                {props.currencySymbol})
                            </>
                        )}
                    </span>
                </h5>
            </a>
            {props.merchant.tarif !== undefined && props.merchant.tarif !== null && (
                <div>
                    <ul>
                        {Object.entries(props.merchant.tarif?.tarifInfoMap)?.map(([propertyName, tarifData]) => (
                            <PPTarifView key={propertyName} tarifData={tarifData} />
                        ))}
                    </ul>
                </div>
            )}
        </li>
    )
}


function PPMerchantView(props) {
    const [t] = useTranslation()
    const auth = useRequireAuth()
    const currentAuth = PPUtils.getCurrentAuthFromAuth(auth)
    if (props.foreignShop === undefined) {
        return null
    }
    let merchantPrices = props?.foreignShop?.merchantPrices
    let price = props?.foreignShop?.price

    let hasSecondPrice = props?.foreignShop?.secondPrice !== "-1,00" && props?.foreignShop?.secondPrice !== "0,00"

    let currencySymbol =
        hasSecondPrice && props?.foreignShop?.secondCurrencySymbol
            ? props?.foreignShop?.secondCurrencySymbol
            : props?.foreignShop?.currencySymbol

    if (merchantPrices.length === 0 && price <= 0) {
        return <p>{t("pricetable.righttab.competitor_tab.no_competitors_found_only_customer")}</p>
    } else if (merchantPrices.length === 0) {
        return <p>{t("pricetable.righttab.competitor_tab.no_competitors_found")}</p>
    }

    //Keine Sortierung im Client bei Soldan - Hier geben die Staffelpreise die Sortierung vor. Das macht der Server.
    let shouldSort = currentAuth.customer.name !== "Soldan"

    if (shouldSort && localStorage.getItem("showTotalPrice") === "true") {
        merchantPrices.sort((m1, m2) => m1.totalPrice - m2.totalPrice)
    }

    /* arausch 11.10.2024 - Wir machen es nur noch bei Umstellung auf Total Price Anzeige 
                            Der Server sollte es schon richtig sortieren und an den Client in korrekter Reihenfolge senden.
    else {
        merchantPrices.sort((m1, m2) => m1.price - m2.price)
    }*/

    let items = merchantPrices.map((x, index) => {
        let key = index + "_" + JSON.stringify(x)
        return (
            <PPMerchantRow
                key={key}
                index={index}
                foreignShop={props?.foreignShop}
                merchant={x}
                currencySymbol={currencySymbol}
            />
        )
    })

    return <ul className="list-group ul-scroll">{items}</ul>
}

export default PPMerchantView
